import { sharedCareScoutQuestions } from './careScoutAppSharedQuestions';
import { sharedCareScoutSections } from './careScoutAppSharedSections';

const questions: Record<string, PolicyFormQuestion> = {
  ...sharedCareScoutQuestions,
  coverageMaximumSpecial: {
    id: 'coverage-maximum',
    questionRef: 'coverageMaximumSpecial',
    title: 'Coverage Maximum',
    type: 'radio',
    required: true,
    options: [
      { id: '50000', value: '$50,000' },
      { id: '100000', value: '$100,000' },
      { id: '150000', value: '$150,000' },
      { id: '200000', value: '$200,000' },
      { id: '250000', value: '$250,000' },
    ],
  },
  dailyBenefitAmount50k: {
    id: 'daily-benefit-amount-50k',
    questionRef: 'dailyBenefitAmount50k',
    title: 'Daily Benefit Amount',
    type: 'radio',
    options: [{ id: '50', value: '$50' }],
    conditional: {
      visible: {
        field: 'coverageMaximumSpecial',
        operator: 'equals',
        value: '50000',
      },
      required: {
        field: 'coverageMaximumSpecial',
        operator: 'equals',
        value: '50000',
      },
    },
  },
  dailyBenefitAmount100k: {
    id: 'daily-benefit-amount-100k',
    questionRef: 'dailyBenefitAmount100k',
    title: 'Daily Benefit Amount',
    type: 'radio',
    options: [
      { id: '50', value: '$50' },
      { id: '100', value: '$100' },
    ],
    conditional: {
      visible: {
        field: 'coverageMaximumSpecial',
        operator: 'equals',
        value: '100000',
      },
      required: {
        field: 'coverageMaximumSpecial',
        operator: 'equals',
        value: '100000',
      },
    },
  },
  dailyBenefitAmount150k: {
    id: 'daily-benefit-amount-150k',
    questionRef: 'dailyBenefitAmount150k',
    title: 'Daily Benefit Amount',
    type: 'radio',
    options: [
      { id: '50', value: '$50' },
      { id: '100', value: '$100' },
      { id: '150', value: '$150' },
      { id: '200', value: '$200' },
    ],
    conditional: {
      visible: {
        field: 'coverageMaximumSpecial',
        operator: 'equals',
        value: '150000',
      },
      required: {
        field: 'coverageMaximumSpecial',
        operator: 'equals',
        value: '150000',
      },
    },
  },

  dailyBenefitAmount200k: {
    id: 'daily-benefit-amount-200k',
    questionRef: 'dailyBenefitAmount200k',
    title: 'Daily Benefit Amount',
    type: 'radio',
    options: [
      { id: '50', value: '$50' },
      { id: '100', value: '$100' },
      { id: '150', value: '$150' },
      { id: '200', value: '$200' },
    ],
    conditional: {
      visible: {
        field: 'coverageMaximumSpecial',
        operator: 'equals',
        value: '200000',
      },
      required: {
        field: 'coverageMaximumSpecial',
        operator: 'equals',
        value: '200000',
      },
    },
  },

  dailyBenefitAmount250k: {
    id: 'daily-benefit-amount-250k',
    questionRef: 'dailyBenefitAmount250k',
    title: 'Daily Benefit Amount',
    type: 'radio',
    options: [
      { id: '50', value: '$50' },
      { id: '100', value: '$100' },
      { id: '150', value: '$150' },
      { id: '200', value: '$200' },
    ],
    conditional: {
      visible: {
        field: 'coverageMaximumSpecial',
        operator: 'equals',
        value: '250000',
      },
      required: {
        field: 'coverageMaximumSpecial',
        operator: 'equals',
        value: '250000',
      },
    },
  },
};

export const careScoutMDFormDefinition: PolicyFormDefinition = {
  sections: [
    {
      id: 'coverage-selection',
      title: 'Coverage Selection',
      subsections: [
        {
          id: 'coverage-selection-questions',
          title: 'Coverage Selection',
          questionGroups: [
            {
              id: 'info-group',
              format: 'grid',
              questions: ['applicantName', 'applicantDob'],
            },
            {
              id: 'coverage-maximum-group',
              format: 'default',
              questions: [
                'coverageMaximumSpecial',
                'dailyBenefitAmount50k',
                'dailyBenefitAmount100k',
                'dailyBenefitAmount150k',
                'dailyBenefitAmount200k',
                'dailyBenefitAmount250k',
                'deductiblePeriod',
                'waiverOfHomeAndCommunityCare',
                'nonforfeitureBenefit',
                'inflationProtection',
              ],
            },
            {
              id: 'couple-status-group',
              format: 'default',
              questions: ['coupleStatus'],
            },
            {
              id: 'couple-status-related-group',
              format: 'default',
              questions: ['spouseName', 'spouseSsn', 'spouseDob', 'spouseCoverageNumber'],
              conditional: {
                visible: {
                  field: 'coupleStatus',
                  operator: 'equals',
                  value: 'yes',
                },
              },
            },
          ],
        },
        {
          id: 'coverage-selection-premium-info',
          title: 'Premium Information',
          questionGroups: [
            {
              id: 'premium-info-group',
              format: 'default',
              questions: ['premiumPaymentMode'],
            },
            {
              id: 'premium-agent-group',
              format: 'default',
              questions: [
                'agentName',
                'haveAgentProducerCode',
                'agentProducerCode',
                'nationalProducerCode',
                'applicationSignedState',
              ],
            },
          ],
        },
      ],
    },
    sharedCareScoutSections.eftPaymentAuth,
    sharedCareScoutSections.applicantProfile,
    sharedCareScoutSections.insurabilityProfile,
    sharedCareScoutSections.medicalQuestions,
    sharedCareScoutSections.socialHistory,
    sharedCareScoutSections.familyHistory,
    sharedCareScoutSections.otherCoverage,
    sharedCareScoutSections.protectionLapse,
    sharedCareScoutSections.producerSignature,
    sharedCareScoutSections.ltcAppOverflowForm,
    sharedCareScoutSections.healthInsuranceAuthorization,
    sharedCareScoutSections.ltcInsurancePersonalWorksheet,
    sharedCareScoutSections.verificationFinancialNonDisclosure,
    sharedCareScoutSections.ltcPotentialRateIncreaseDisclosure,
    sharedCareScoutSections.licensedInsuranceProducerInformation,
  ],
  questions,
};
